import { createFileRoute } from '@tanstack/react-router'

import PaymentReturn from '@/screens/account/components/payment/PaymentReturn'

/**
 * Where every gateway sends the browser back. No `validateSearch`, on
 * purpose: `PaymentReturn` reads the gateway's params raw — see
 * `subscription-search.ts`.
 */
export const Route = createFileRoute('/_app/payment/return')({
  component: PaymentReturnScreen,
})

function PaymentReturnScreen() {
  return <PaymentReturn landing="return" />
}
